import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  ref: "container",
  class: "swiper pinboard relative flex h-full w-full lg:items-center lg:justify-center"
}
const _hoisted_2 = {
  key: 1,
  class: "absolute bottom-40 flex justify-end lg:w-145"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_biz_icon = _resolveComponent("biz-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["pinboard-items swiper-wrapper mb-8 lg:mb-0", 
                _ctx.editMode ? 'flex flex-col gap-4' : 'flex flex-nowrap lg:relative lg:h-0 lg:w-0'
            ])
    }, [
      _renderSlot(_ctx.$slots, "items")
    ], 2),
    (!_ctx.editMode && !_ctx.isDesktop)
      ? _renderSlot(_ctx.$slots, "slidebar", {
          key: 0,
          total: _ctx.items.length,
          current: _ctx.currentIndex
        })
      : _createCommentVNode("", true),
    (!_ctx.editMode && _ctx.isDesktop)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("button", {
            class: "inline-flex border-b border-transparent font-medium transition-colors hover:border-current",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.shuffleItems && _ctx.shuffleItems(...args)))
          }, [
            _createVNode(_component_biz_icon, {
              name: "shuffle",
              class: "mr-3 h-5 w-5 fill-current text-current"
            }),
            _createElementVNode("span", null, _toDisplayString(_ctx.shuffleText), 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 512))
}